import { AppThunk, FETCH_CHATGROUPS_SUCCESS, FETCH_TOTAL_AVAILABLE_QUERIES, SET_CHAT_GROUP_ID, SET_SELECTED_MODEL } from "../types";
import apis from "../../utils/apis";
import { showFeedbackModal } from "./UserFeedbackActions";
import { ChatHistoryResponse } from "../../components/Chat/types";
import { handleApiError } from "./utils/utils";

export const FETCH_SERVICES_SUCCESS = 'FETCH_SERVICES_SUCCESS';

export const getUserID = () => {
  try {
    const stored = sessionStorage.getItem("userInfo");
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed.userId || parsed.UserID || parsed.user_id || null;
    }
  } catch (e) {
  }
  return null;
};

export const getUserType = () => {
  try {
    const stored = sessionStorage.getItem("userInfo");
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed.userType || parsed.UserType || parsed.user_type || null;
    }
  } catch (e) {
  }
  return null;
};

export const getKycStatus = () => {
  try {
    const stored = sessionStorage.getItem("userInfo");
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed.kycStatus || parsed.KycStatus || parsed.kyc_status || null;
    }
  } catch (e) {
  }
  return null;
};

export interface Citation {
  id: string;
  law: string;
  paragraph: string;
  section: string;
  snippet: string;
  title: string;
  favicon?: string;
  url: string;
  number?: number;
}

export interface SomeInputType {
  LCMID: string;
  UserID: string;
  Section: string;
  SectionData: string;
  UserType: string
}


export interface ApiResponse {
  ConfirmMessage: string;
  DataID: string;
  NextSection: string;
  Output: string;
  Section: string;
  SectionData: string;
  UserFullName: string;
  UserID: string;
  LCM?: any;
}

export interface AIModel {
  model_content: string;
  model_display_name: string;
  model_id: number;
  model_name: string;
  model_role: string;
  total_available_queries?: string | number;
  is_user_index?: boolean;
}


export interface ServiceAPIResponse {
  LawAgentResponse?: string;
  final_response?: string;
  LawCitations?: Citation[];
  progress?: any[];
  UnifiedResponse?: string;
  ContractAnalysisResponse?: string;
  ContractGeneratorResponse?: string;
  CaseAgentResponse?: string;
  TaxAgentResponse?: string;
  ChatResponse?: string;
  ChatGroupID?: string;
  ChatID?: string; 
  ChatTitle?: string;    
  ContractGenerationResponse?: string
  message?: string;
  Citations?: Citation[];
}

export interface ChatGroupData {
  AIType: string,
  ChatGroupID: string,
  ChatTitle: string,
  CreationDate: string,
  LastModified: string,
  UserID: string,
  id: string,
  status: string,
  // Research chat fields (from ResearchChatGroup)
  uuid?: string,
  title?: string,
  last_message_at?: string,
  updated_at?: string,
  created_at?: string,
  total_messages?: number,
  country?: string,
  sources?: Array<{ source_type: string; source_identifier: string; source_name?: string }>,
}


export const setSelectedModel = (model: AIModel) => {
  localStorage.setItem('selectedModel', JSON.stringify(model));
  return {
    type: SET_SELECTED_MODEL,
    payload: model,
  };
};


export const setChatGroupIDStore = (chatGroupID: string) => {
  localStorage.setItem('chatGroupID', chatGroupID);
  return {
    type: SET_CHAT_GROUP_ID,
    payload: chatGroupID,
  };
};

export const addChatGroup = (chatGroup: ChatGroupData) => ({
  type: 'ADD_CHAT_GROUP',
  payload: chatGroup,
});

export const callLCMAPI = async (data: SomeInputType): Promise<ApiResponse> => {
  try {
    const response = await apis({
      method: "POST",
      url: "ponsai/lcm/generateLCM",
      data: data
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};


export const callServiceAPI = async (
  service: string,
  data: any,
  files: File[] = [],
  groupID: string = ''
): Promise<ServiceAPIResponse> => {
  let endpoint;
  let payload: FormData | Record<string, any>;
  let headers = {};

  const commonData = {
    ...data,
    GroupID: groupID,
  };

  switch (service) {
    case 'Orchestrator':
      endpoint = '/ai/router';
      payload = {
        ...commonData,
        service
      }
      break;
    case 'LawAgent':
      endpoint = 'ai/generate_law_research';
      payload = commonData;
      break;
    case 'TaxAgent':
      endpoint = 'ai/generate_tax_research';
      payload = commonData;
      break;
    case 'CaseAgent':
      endpoint = 'ai/generate_case_research';
      payload = commonData;
      break;
      case 'ContractAdvisor':
        endpoint = '/ai/generate_contract_analysis';
        const formData = new FormData();
        formData.append('GroupID', groupID);
        if (files.length > 0) {
          files.forEach((file) => {
            formData.append('Files', file);
          });
        } else {
          formData.append('Files', new Blob(), ''); 
        }
        Object.keys(data).forEach((key) => {
          formData.append(key, data[key]);
        });
        payload = formData;
        break;
    case 'ContractGenerator':
      endpoint = 'ponsai/contractGenerator';
      payload = commonData;
      break;
    case 'CompanyAgent':
      endpoint = 'ai/company_agent/chat';
      payload = {
        ...data,
      };
      break;
    case 'CustomAgent':
      endpoint = 'ai/custom_agent/chat';
      payload = {
        ...data,
      };
      break;
    default:
      throw new Error('Service not recognized');
  }

  try {
    const response = await apis({
      method: 'POST', 
      url: endpoint,
      data: payload,
      headers: headers,
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};


export interface ChatGroupData {
  AIType: string,
  ChatGroupID: string,
  ChatTitle: string,
  CreationDate: string,
  LastModified: string,
  UserID: string,
  id: string,
  status: string,
  // Research chat fields (from ResearchChatGroup)
  uuid?: string,
  title?: string,
  last_message_at?: string,
  updated_at?: string,
  created_at?: string,
  total_messages?: number,
  country?: string,
  sources?: Array<{ source_type: string; source_identifier: string; source_name?: string }>,
}

export const chatGroupApi = (AIType: string): AppThunk => async (dispatch) => {
  try {
    let response = await apis({
      method: "POST",
      url: "ai/get_chat_groups",
      data: {
        AIType,
      }
    })

    if (response && response.status === 200) {
      dispatch({
        type: FETCH_CHATGROUPS_SUCCESS,
        payload: response.data.Chats
      });
      return response.data.Chats
    } else {
      handleApiError(response, dispatch)
    }

  } catch (err) {
    handleApiError(err, dispatch)
  }

}


export const createChatGroup = (): AppThunk<Promise<{ GroupID: string }>> => async (dispatch) => {
  try {
    const response = await apis({
      method: 'POST',
      url: 'ai/create_chat_group',
      data: { AIType: 'Orchestrator' },
    });
    if (response.status === 200) {
      return response.data; 
    } else {
      throw new Error('Failed to create chat group');
    }
  } catch (error) {
    throw error;
  }
};

export const uploadFiles = (files: File[], groupID: string): AppThunk<any> => async (dispatch: any) => {
  try {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file));
    formData.append('GroupID', groupID);
    const response = await apis({
      method: 'POST',
      url: 'ai/upload_contracts',
      data: formData,
    });
    if (response.status === 200) {
      return response.data; 
    } else {
      throw new Error('Failed to upload files');
    }
  } catch (error) {
    throw error; 
  }
};

export const stopOrchestratorStream = (data: { group_id: string }): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const response = await apis({
      method: 'POST',
      url: 'ai/orchestrator/stop',
      data,
    });
    if (response.status !== 200) {
      throw new Error('Failed to stop stream');
    }
  } catch (error) {
    throw error;
  }
};

export const chatHistoryApi = (
  AIType: string,
  GroupID: string,
  signal: AbortSignal
): AppThunk<Promise<ChatHistoryResponse>> => async (dispatch) => {
  try {
    let response = await apis({
      method: "POST",
      url: "ai/get_ai_chat_history",
      data: { AIType, GroupID },
      signal: signal, 
    });
    if (response && response.status === 200) {
      return response.data as ChatHistoryResponse;
    } else {
      handleApiError(response, dispatch)
      throw new Error('Unable to fetch chat history');

    }
  } catch (err: any) {
    if (err.name !== 'AbortError') {
      handleApiError(err, dispatch)
    }
    throw err;
  }
};

export const deleteChatGroup = (GroupID: string,): AppThunk => async (dispatch) => {
  try {
    let response = await apis({
      method: "POST",
      url: "ai/delete_chat_group",
      data: {
        GroupID,
      }
    })

    if (response && response.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: 'Chat deleted',
        modalType: 'success',
        duration: 3000
      }));
      return response.data
    } else {
      handleApiError(response, dispatch)
    }

  } catch (err) {
    handleApiError(err, dispatch)
  }
}


export const submitChatFeedback = (
  ChatID: string,
  GroupID: string,
  Like: string,
  Dislike: string,
  Comment: string
): AppThunk => async (dispatch) => {
  try {
    let response = await apis({
      method: "POST",
      url: "ai/chat_feedback",
      data: {
        UserID: getUserID(),
        UserType: getUserType(),
        ChatID,
        GroupID,
        Like,
        Dislike,
        Comment
      }
    });

    if (response && response.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: 'Feedback submitted',
        modalType: 'success',
        duration: 3000
      }));
      return response.data;
    } else {
      handleApiError(response, dispatch)
    }
  } catch (err) {
    handleApiError(err, dispatch)
  }
};


export const getAiModels = (project_id?: string) => {
  return async (dispatch: any) => {
    try {
      const response = await apis({
        method: "POST",
        url: "/ai/models",
        data:{
          project_id
        }
      })
      if (response && response.status === 200) {
        
        dispatch({ type: FETCH_SERVICES_SUCCESS, payload: response.data.services as AIModel[]});
        dispatch({ type: FETCH_TOTAL_AVAILABLE_QUERIES, payload: response.data.total_available_queries});
        return response.data.services
      } else {
        handleApiError(response, dispatch)
      }
    } catch (err) {
      handleApiError(err, dispatch)
    }

  }
}

export const deleteChatHistory = (GroupID: string, UserID: string, UserType: string) => {
  return async (dispatch: any) => {
    try {
      const response = await apis({
        method: "POST",
        url: "ponsai/deleteChatHistory",
        data: {
          GroupID,
          UserID,
          UserType
        }
      })
      if (response && response.status === 200) {
        return response.data
      } else {
        handleApiError(response, dispatch)
      }
    } catch (err) {
      handleApiError(err, dispatch)
    }

  }
}

export const updateChatTitle = (GroupID: string, newTitle: string) => {
  return async (dispatch: any) => {
    try {
      const response = await apis({
        method: "POST",
        url: "ai/update_chat_title",
        data: {
          GroupID: GroupID,
          NewTitle: newTitle
        }
      })
      if (response && response.status === 200) {
        return response.data
      } else {
        handleApiError(response, dispatch)
      }
    } catch (err) {
      handleApiError(err, dispatch)
    }
  }
}


// =============================================================================
// Research API Functions (new backend endpoints)
// =============================================================================

export interface ResearchSource {
  source_type: string;       // 'jurisdiction_law' | 'jurisdiction_case' | 'user_datasource'
  source_identifier: string; // Country code or datasource UUID
  source_name?: string;
  index_name?: string;
  document_count?: number;
  description?: string;
  status?: string;           // e.g. 'ready', 'processing' for user datasources
}

export interface ResearchChatGroup {
  uuid: string;
  title: string;
  country: string | null;
  status: string;
  total_messages: number;
  total_tokens_used: number;
  last_message_at: string | null;
  matter_uuid: string | null;
  sources: ResearchSource[];
  created_at: string;
  updated_at: string;
}

export interface ResearchQueryResult {
  correlation_id: string;
  message_uuid: string;
  sequence_number: number;
  chat_uuid: string;
  status: string;
}

export const researchListChatGroups = (
  page: number = 1,
  pageSize: number = 20,
  status?: string,
  matterId?: number
): AppThunk<Promise<{ items: ResearchChatGroup[]; total: number }>> => async (dispatch) => {
  try {
    const params = new URLSearchParams({ page: String(page), page_size: String(pageSize) });
    if (status) params.set('status', status);
    if (matterId) params.set('matter_id', String(matterId));

    const response = await apis({
      method: "GET",
      url: `research/chat-groups?${params.toString()}`,
    });

    if (response?.status === 200) {
      dispatch({ type: FETCH_CHATGROUPS_SUCCESS, payload: response.data.items });
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to list research chats');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchCreateChatGroup = (data: {
  title?: string;
  country?: string;
  matter_id?: number;
  matter_uuid?: string;
  sources?: ResearchSource[];
}): AppThunk<Promise<ResearchChatGroup>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "POST",
      url: "research/chat-groups",
      data,
    });

    if (response?.status === 201) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to create research chat');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchGetChatGroup = (chatUuid: string): AppThunk<Promise<ResearchChatGroup>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "GET",
      url: `research/chat-groups/${chatUuid}`,
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to get research chat');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchUpdateChatGroup = (
  chatUuid: string,
  data: { title?: string; status?: string; country?: string; sources?: ResearchSource[] }
): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "PUT",
      url: `research/chat-groups/${chatUuid}`,
      data,
    });

    if (response?.status !== 200) {
      handleApiError(response, dispatch);
    }
  } catch (err) {
    handleApiError(err, dispatch);
  }
};

export const researchDeleteChatGroup = (chatUuid: string): AppThunk => async (dispatch) => {
  try {
    const response = await apis({
      method: "DELETE",
      url: `research/chat-groups/${chatUuid}`,
    });

    if (response?.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: 'Research chat deleted',
        modalType: 'success',
        duration: 3000,
      }));
      return response.data;
    } else {
      handleApiError(response, dispatch);
    }
  } catch (err) {
    handleApiError(err, dispatch);
  }
};

export const researchSendQuery = (
  chatUuid: string,
  query: string,
  documentChunks?: string[]
): AppThunk<Promise<ResearchQueryResult>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "POST",
      url: `research/chat-groups/${chatUuid}/query`,
      data: { query, document_chunks: documentChunks || [] },
    });

    if (response?.status === 202) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to send research query');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchStopProcessing = (chatUuid: string): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "POST",
      url: `research/chat-groups/${chatUuid}/stop`,
    });

    if (response?.status !== 200) {
      handleApiError(response, dispatch);
    }
  } catch (err) {
    handleApiError(err, dispatch);
  }
};

export const researchGetMessages = (
  chatUuid: string,
  page: number = 1,
  pageSize: number = 50
): AppThunk<Promise<{ items: any[]; total: number }>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "GET",
      url: `research/chat-groups/${chatUuid}/messages?page=${page}&page_size=${pageSize}`,
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to get messages');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchGetMessageContent = (
  chatUuid: string,
  messageUuid: string
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "GET",
      url: `research/chat-groups/${chatUuid}/messages/${messageUuid}/content`,
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to get message content');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchConfirmCompletion = (
  chatUuid: string,
  messageUuid: string,
  completionData: {
    chat_name?: string;
    citation_count?: number;
    processing_time_ms?: number;
    summary?: string;
    blob_path?: string;
    prompt_tokens?: number;
    completion_tokens?: number;
    total_tokens?: number;
    model_used?: string;
  }
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "POST",
      url: `research/chat-groups/${chatUuid}/messages/${messageUuid}/confirm-completion`,
      data: completionData,
    });

    if (response?.status === 200) {
      return response.data;
    }
    // Silently ignore errors — this is a best-effort reconciliation
  } catch {
    // Non-critical: the AI engine's internal notification may have succeeded
  }
};

export const researchSubmitFeedback = (
  chatUuid: string,
  messageUuid: string,
  feedbackType: 'like' | 'dislike',
  comment?: string
): AppThunk => async (dispatch) => {
  try {
    const response = await apis({
      method: "POST",
      url: `research/chat-groups/${chatUuid}/messages/${messageUuid}/feedback`,
      data: { feedback_type: feedbackType, comment },
    });

    if (response?.status === 200) {
      dispatch(showFeedbackModal({
        showModal: true,
        message: 'Feedback submitted',
        modalType: 'success',
        duration: 3000,
      }));
    } else {
      handleApiError(response, dispatch);
    }
  } catch (err) {
    handleApiError(err, dispatch);
  }
};

export const researchUploadAttachment = (
  chatUuid: string,
  files: File[]
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const formData = new FormData();
    files.forEach((file) => formData.append('file', file));

    const response = await apis({
      method: "POST",
      url: `research/chat-groups/${chatUuid}/attachments`,
      data: formData,
    });

    if (response?.status === 201) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to upload attachment');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchGetAvailableSources = (): AppThunk<Promise<{
  jurisdiction_sources: ResearchSource[];
  user_datasources: ResearchSource[];
}>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "GET",
      url: "research/available-sources",
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to get available sources');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchGetContextInfo = (chatUuid: string): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "GET",
      url: `research/chat-groups/${chatUuid}/context`,
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to get context info');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};


// =============================================================================
// Research Collaborator Actions
// =============================================================================

export const researchListCollaborators = (
  chatUuid: string
): AppThunk<Promise<any[]>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "GET",
      url: `research/chat-groups/${chatUuid}/collaborators`,
    });

    if (response?.status === 200) {
      return response.data?.collaborators || response.data || [];
    } else {
      handleApiError(response, dispatch);
      return [];
    }
  } catch (err) {
    handleApiError(err, dispatch);
    return [];
  }
};

export const researchAddCollaborator = (
  chatUuid: string,
  collaboratorUserId: number | string,
  access: 'view' | 'edit' | 'admin' = 'view'
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    // Detect whether the value is a numeric ID or a UUID string
    const isNumeric = typeof collaboratorUserId === 'number' || /^\d+$/.test(String(collaboratorUserId));
    const data = isNumeric
      ? { collaborator_user_id: Number(collaboratorUserId), access }
      : { collaborator_uuid: String(collaboratorUserId), access };

    const response = await apis({
      method: "POST",
      url: `research/chat-groups/${chatUuid}/collaborators`,
      data,
    });

    if (response?.status === 200 || response?.status === 201) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to add collaborator');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchUpdateCollaboratorAccess = (
  chatUuid: string,
  collaboratorUuid: string,
  access: 'view' | 'edit' | 'admin'
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "PATCH",
      url: `research/chat-groups/${chatUuid}/collaborators/${collaboratorUuid}`,
      data: { access },
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to update collaborator access');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchRemoveCollaborator = (
  chatUuid: string,
  collaboratorUuid: string
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "DELETE",
      url: `research/chat-groups/${chatUuid}/collaborators/${collaboratorUuid}`,
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to remove collaborator');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};

export const researchUpdateSharing = (
  chatUuid: string,
  isShared: boolean
): AppThunk<Promise<any>> => async (dispatch) => {
  try {
    const response = await apis({
      method: "PUT",
      url: `research/chat-groups/${chatUuid}/sharing`,
      data: { is_shared: isShared },
    });

    if (response?.status === 200) {
      return response.data;
    } else {
      handleApiError(response, dispatch);
      throw new Error('Failed to update sharing');
    }
  } catch (err) {
    handleApiError(err, dispatch);
    throw err;
  }
};
